import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ImportComponent } from '../import.component';

@Component({
    selector: 'app-distribution-import',
    templateUrl: './distribution-import.component.html',
    styleUrls: ['./distribution-import.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ImportComponent]
})
export class DistributionImportComponent {
}
